import React, { useState, useEffect } from "react";
import firebase from "../../Firebase/FirebaseConfig";
import "./AyBannerImage.css";
import { Country } from "country-state-city";
import axios from "axios";

import { useNavigate } from "react-router-dom";

const storage = firebase.storage();
// const auth = firebase.auth();
const projectFireStore = firebase.firestore();

const AyBannerImage = () => {
  const navigate = useNavigate();
  const countries = Country.getAllCountries();
  // console.log("countries", countries);

  const [errorMessage, setErrorMessage] = useState("");
  const [disableLoginButton, setDisableLoginButton] = useState(false);

  const [coverImageId, setCoverImageId] = useState("");
  const [coverImageText, setCoverImageText] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [url, setUrl] = useState("");
  const [type, setType] = useState("");
  const [isGlobal, setIsGlobal] = useState(true);
  const [city, setCity] = useState("India");
  const [metaDataId, setMetaDataId] = useState("");
  const [metaDataName, setMetaDataName] = useState("");
  const [metaDataDescription, setMetaDataDescription] = useState("");
  const [metaDataConfirmationURL, setMetaDataConfirmationURL] = useState("");
  const [metaDataAndroidPackageId, setMetaDataAndroidPackageId] = useState("");
  const [metaDataIOSPackageId, setMetaDataIOSPackageId] = useState("");
  const [metaDataRevenueCatPackageId, setMetaDataRevenueCatPackageId] =
    useState("");

  const [quickReads, setQuickReads] = useState([]);
  const [programData, setProgramData] = useState([]);

  const getQuickreadData = () => {
    axios
      // .get
      // "http://127.0.0.1:8000/magicFood/getAllActiveQuickReadsForAdmin/"
      // ()
      .get(
        "https://qrs.btartisticyoga.com/magicFood/getAllActiveQuickReadsForAdmin/"
      )
      .then((res) => {
        // console.log("quickRead", res.data.data);
        setQuickReads(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getProgramData = () => {
    axios
      // .get
      // "http://127.0.0.1:8000/magicFood/getAllActiveQuickReadsForAdmin/"
      // ()
      .get(
        "https://us-central1-btay-project-1551779459124.cloudfunctions.net/AY/get/programInAppMapping"
      )
      .then((res) => {
        console.log("programs", res?.data[0].data[2].classes);
        setProgramData(res?.data[0].data[2].classes);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getProgramData();
    getQuickreadData();
    console.log("metaDataId", metaDataId);
    console.log("imageUrl", imageUrl);
  }, [metaDataId, imageUrl]);

  const handleNotificationError = () => {
    if (errorMessage) {
      setErrorMessage("");
    }
  };

  const handleChange = async (e) => {
    // setForm(formData)
    handleNotificationError();
    if (e.target.files[0]) {
      setImageUrl(e.target.files[0]);
    }
  };

  const handleUpload = async (e) => {
    e.preventDefault();

    if (
      !coverImageText || !imageUrl || !type || type == "quickReads"
        ? !metaDataId
        : type == "program"
        ? !metaDataId || !metaDataDescription
        : type == "offer"
        ? !metaDataAndroidPackageId ||
          !metaDataIOSPackageId ||
          !metaDataRevenueCatPackageId
        : null
    ) {
      setErrorMessage("Enter all details");
      return;
    }

    setDisableLoginButton(true);
    const uploadTask = storage.ref(`files/${imageUrl.name}`).put(imageUrl);
    // const collectionRef = projectFireStore.collection("bannerCoverImagesTest");
    const collectionRef = projectFireStore.collection("bannerCoverImages");
    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
        //   setProgress(progress);
      },
      (error) => {
        console.log(error);
      },
      () => {
        storage
          .ref("files")
          .child(imageUrl.name)
          .getDownloadURL()
          .then((url) => {
            setUrl(url);
            // {In this place you have to call that api of add files}

            collectionRef
              .add({
                coverImageId: coverImageId,
                coverImageText: coverImageText,
                imageUrl: url,
                isActive: true,
                isGlobal: isGlobal,
                type: type,
                // metaData: { id: metaDataId, name: metaDataName },
                // city: [city],
                // city: ["element1", "element2", "element3"],
                metaData:
                  type == "quickReads"
                    ? {
                        id: metaDataId,
                      }
                    : type == "program"
                    ? {
                        id: metaDataId,
                        name: metaDataName,
                        description: metaDataDescription,
                      }
                    : type == "event"
                    ? {
                        id: metaDataId,
                        name: metaDataName,
                        description: metaDataDescription,
                        confirmationURL: metaDataConfirmationURL,
                      }
                    : { id: metaDataId, name: metaDataName },
              })
              .then(() => {
                setDisableLoginButton(false);
                alert("Banner Image Added Successfully");
                navigate("/home");
                setCoverImageId("");
                setCoverImageText("");
                setImageUrl("");
                setType("");
                setUrl("");
                setMetaDataId("");
                setMetaDataName("");
              });
          });
      }
    );
  };

  return (
    <>
      {/* <Header className="mb-3" /> */}

      <div className="Apps mb-3">
        <div className="breadcrumbcontainer">
          <div className="breadcrumb-nav">
            <img src="/assets/rightchevron.png" alt="" />
            <span className="submitBtn">Post Banner Images </span>
          </div>
        </div>

        <form className="mb-3">
          {/* <div className="mb-3">
            <label htmlFor="coverImageId" className=  "form-label">
              coverImageId
            </label>
            <input
              type="text"
              className="form-control"
              id="coverImageId"
              aria-describedby="coverImageId"
              value={coverImageId}
              onChange={(e) => {
                setCoverImageId(e.target.value);
              }}
              required
            />
          </div> */}

          <div className="mb-3">
            <label htmlFor="coverImageText" className="form-label">
              Cover image Text
            </label>
            <input
              type="text"
              className="form-control"
              id="coverImageText"
              aria-describedby="coverImageText"
              value={coverImageText}
              onChange={(e) => {
                handleNotificationError();
                setCoverImageText(e.target.value);
              }}
              required
            />
          </div>

          <div className="mb-3">
            <label htmlFor="file" className="form-label">
              Cover image
            </label>
            <input
              type="file"
              className="form-control"
              id="file"
              aria-describedby="file"
              onChange={handleChange}
              required
            />
          </div>

          <div className="mb-3">
            <label htmlFor="type" className="form-label">
              Category
            </label>
            <select
              class="form-select"
              aria-label="Default select example"
              value={type}
              onChange={(e) => {
                handleNotificationError();
                setType(e.target.value);
              }}
            >
              <option selected value="" disabled>
                Open this select Category
              </option>
              <option value="quickReads">Quick Read</option>
              <option value="program">Program</option>
              <option value="video">Video</option>
              <option value="event">Event</option>
              <option value="personalise">personalize</option>
              <option value="offer">Offers</option>
            </select>
          </div>

          {type == "quickReads" && (
            <div>
              <div className="mb-3">
                <label htmlFor="metaDataId" className="form-label">
                  {type}
                </label>
                <select
                  id="metaDataId"
                  class="form-select"
                  aria-label="metaDataId"
                  value={metaDataId}
                  onChange={(e) => {
                    setMetaDataId(e.target.value);
                  }}
                >
                  <option selected disabled value="">
                    Open this select QuickReads
                  </option>
                  {quickReads.map((item, index) => {
                    return (
                      <option key={index} value={item.id}>
                        {item.name}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
          )}

          {type == "program" && (
            <div>
              <div className="mb-3">
                <label htmlFor="metaDataId" className="form-label">
                  {type}
                </label>
                <select
                  id="metaDataId"
                  class="form-select"
                  aria-label="metaDataId"
                  value={metaDataId}
                  onChange={(e) => {
                    setMetaDataId(e.target.value);
                  }}
                >
                  <option value="" selected disabled>
                    Open this select Programs
                  </option>
                  {programData.map((item, index) => {
                    return (
                      <option key={index} value={`${item.id} ${item.context}`}>
                        {item.context}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="mb-3">
                <label htmlFor="metaDataDescription" className="form-label">
                  Description
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="metaDataDescription"
                  aria-describedby="metaDataDescription"
                  value={metaDataDescription}
                  onChange={(e) => {
                    setMetaDataDescription(e.target.value);
                  }}
                  required
                />
              </div>
            </div>
          )}

          {type == "event" && (
            <div>
              <div className="mb-3">
                <label htmlFor="metaDataName" className="form-label">
                  {type} name
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="metaDataName"
                  aria-describedby="metaDataName"
                  value={metaDataName}
                  onChange={(e) => {
                    setMetaDataName(e.target.value);
                  }}
                  required
                />
              </div>
              <div className="mb-3">
                <label htmlFor="metaDataDescription" className="form-label">
                  Description
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="metaDataDescription"
                  aria-describedby="metaDataDescription"
                  value={metaDataDescription}
                  onChange={(e) => {
                    setMetaDataDescription(e.target.value);
                  }}
                  required
                />
              </div>

              <div className="mb-3">
                <label htmlFor="confirmationURL" className="form-label">
                  Confirmation URL
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="confirmationURL"
                  aria-describedby="confirmationURL"
                  value={metaDataConfirmationURL}
                  onChange={(e) => {
                    setMetaDataConfirmationURL(e.target.value);
                  }}
                  required
                />
              </div>
              <div className="mb-3">
                <label htmlFor="type" className="form-label">
                  Country
                </label>
                <select
                  class="form-select"
                  aria-label="Default select example"
                  value={city}
                  onChange={(e) => {
                    setCity(e.target.value);
                  }}
                >
                  {/* <option selected>Open this select Category</option> */}
                  {countries.map((item, index) => {
                    return (
                      <option selected value={item.name}>
                        {item.name}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
          )}

          {type == "offer" && (
            <div>
              <div className="mb-3">
                <label
                  htmlFor="metaDataAndroidPackageId"
                  className="form-label"
                >
                  Android Package Id
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="metaDataAndroidPackageId"
                  aria-describedby="metaDataAndroidPackageId"
                  value={metaDataAndroidPackageId}
                  onChange={(e) => {
                    setMetaDataAndroidPackageId(e.target.value);
                  }}
                  required
                />
              </div>
              <div className="mb-3">
                <label htmlFor="metaDataIOSPackageId" className="form-label">
                  IOS Package Id
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="metaDataIOSPackageId"
                  aria-describedby="metaDataIOSPackageId"
                  value={metaDataIOSPackageId}
                  onChange={(e) => {
                    setMetaDataIOSPackageId(e.target.value);
                  }}
                  required
                />
              </div>

              <div className="mb-3">
                <label
                  htmlFor="metaDataRevenueCatPackageId"
                  className="form-label"
                >
                  Revenue Cat Package Id
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="metaDataRevenueCatPackageId"
                  aria-describedby="metaDataRevenueCatPackageId"
                  value={metaDataRevenueCatPackageId}
                  onChange={(e) => {
                    setMetaDataRevenueCatPackageId(e.target.value);
                  }}
                  required
                />
              </div>
            </div>
          )}

          {type == "video" && (
            <div>
              <div className="mb-3">
                <label
                  htmlFor="metaDataAndroidPackageId"
                  className="form-label"
                >
                  Video Id
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="metaDataAndroidPackageId"
                  aria-describedby="metaDataAndroidPackageId"
                  value={metaDataId}
                  onChange={(e) => {
                    setMetaDataId(e.target.value);
                  }}
                  required
                />
              </div>
              <div className="mb-3">
                <label htmlFor="metaDataIOSPackageId" className="form-label">
                  Video Name
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="metaDataIOSPackageId"
                  aria-describedby="metaDataIOSPackageId"
                  value={metaDataName}
                  onChange={(e) => {
                    setMetaDataName(e.target.value);
                  }}
                  required
                />
              </div>
            </div>
          )}

          <div className="mb-3">
            <label class="form-controls">
              <input
                type="checkbox"
                name="checkbox-checked"
                defaultChecked={isGlobal}
                onChange={() => {
                  setIsGlobal(!isGlobal);
                }}
              />
              isGlobal
            </label>
          </div>
          {!isGlobal && (
            <>
              {/* <div className="mb-3">
              <label htmlFor="city" className="form-label">
                city
              </label>
              <input
                type="text"
                className="form-control"
                id="city"
                aria-describedby="city"
                value={city}
                onChange={(e) => {
                  setCity(e.target.value);
                }}
                required
              />
            </div> */}
              <div className="mb-3">
                <label htmlFor="type" className="form-label">
                  Country
                </label>
                <select
                  class="form-select"
                  aria-label="Default select example"
                  value={city}
                  onChange={(e) => {
                    setCity(e.target.value);
                  }}
                >
                  {/* <option selected>Open this select Category</option> */}
                  {countries.map((item, index) => {
                    return (
                      <option selected value={item.name}>
                        {item.name}
                      </option>
                    );
                  })}
                  {/* <option selected value="quickReads">
                    Quick Read
                  </option>
                  <option value="video">Video</option>
                  <option value="program">Program</option>
                  <option value="event">Event</option> */}
                </select>
              </div>
            </>
          )}
          <p className="Login_error">{errorMessage}</p>
          <button
            disabled={disableLoginButton}
            type="submit"
            className="btn btn-primary"
            onClick={handleUpload}
          >
            Submit
          </button>
        </form>
      </div>
    </>
  );
};

export default AyBannerImage;

//   const submitAyBannerImage = async (e) => {
//     e.preventDefault();
//     const obj = {
//       coverImageId: coverImageId,
//       coverImageText: coverImageText,
//       imageUrl: url,
//       isActive: true,
//       isGlobal: true,
//       type: type,
//     };
//     // await fetch("http://3.110.120.103:9007/magicFood/createQuickReads/", {
//     await fetch(
//       "http://127.0.0.1:5001/btay-project-1551779459124/us-central1/AY/create/bannerCoverImages",
//       {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(obj),
//         redirect: "follow",
//       }
//     )
//       .then((response) => response.json())
//       .then((result) => {
//         console.log("result", result);
//         setCoverImageId("");
//         setCoverImageText("");
//         setImageUrl("");
//         setType("");
//         alert("bannerImage added Successfully");
//       })
//       .catch((error) => {
//         console.log("error", error);
//       });
//   };
